import {
  EXAM_CENTER_GET_BEGIN,
  EXAM_CENTER_GET_SUCCESS,
  EXAM_CENTER_GET_FAILURE,
  EXAM_CENTER_UPDATE_BEGIN,
  EXAM_CENTER_UPDATE_SUCCESS,
  EXAM_CENTER_UPDATE_FAILURE,
  EXAM_CENTER_CREATE_BEGIN,
  EXAM_CENTER_CREATE_SUCCESS,
  EXAM_CENTER_CREATE_FAILURE,
  EXAM_CENTER_DELETE_BEGIN,
  EXAM_CENTER_DELETE_SUCCESS,
  EXAM_CENTER_DELETE_FAILURE,
} from "../actionTypes";

const initialState = {
  centers: [],
  loading: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case EXAM_CENTER_GET_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case EXAM_CENTER_GET_SUCCESS: {
      return {
        ...state,
        centers: action.payload,
        loading: false,
        error: null,
      };
    }
    case EXAM_CENTER_GET_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case EXAM_CENTER_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case EXAM_CENTER_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case EXAM_CENTER_UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case EXAM_CENTER_CREATE_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case EXAM_CENTER_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case EXAM_CENTER_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case EXAM_CENTER_DELETE_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case EXAM_CENTER_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case EXAM_CENTER_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
